import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import AllStarRankings from '../../pages/AllStarRankings.jsx';
import CommGross from '../../pages/CommGross.jsx';
import Commissions from '../../pages/Commissions.jsx';
import HRReportPage from '../../pages/HRReport.jsx';
import Landing from '../../pages/Landing.jsx';
import OrderEntryPage from '../../pages/OrderEntry.jsx';
import OutstandingOrders from '../../pages/OutstandingOrders.jsx';
import OutstandingOrdersTMS from '../../pages/OutstandingOrdersTMS.jsx';
import Page404 from '../../pages/Page404.jsx';
import BankPostingPage from '../BankPosting/index.jsx';
import CustomerSummary from '../CustomerSummary/CustomerSummary.jsx';
import DailySummaryPage from '../DailySummary/index.js';
// import TZMMSPOStatus from '../../pages/TZMMSPOStatus.jsx';
import ECGViewer from '../ECGViewer/ECGViewer.jsx';
import EnrollmentsPage from '../Enrollments/EnrollmentsPage.jsx';
import InvTrackerPage from '../Inv-Tracker/index.jsx';
import OrderRequirementsRoute from '../OrderRequirements/index.jsx';
import ParseInvoicePage from '../ParseInvoice/ParseInvoicePage.jsx';
import ProdMgrs from '../ProdMgrs/ProdMgrsPage.jsx';
import ProductsOnBackOrderPage from '../ProductsOnBackOrder/ProductsOnBackOrderPage.jsx';
import TerrPerformance from '../TerrPerformance';
import TrackingInfoPage from '../trackinginfo/pages/TrackingInfoPage.jsx';
import TZMMSActivityPage from '../TZMMS-Activity/index.js';
import TZMMSInvPage from '../TZMMS-INV/TZMMSInvPage.jsx';
import ProtectedRoute from './ProtectedRoute.jsx';

function ProtectedOrderEntryRoute() {
  const location = useLocation();
  const params = new URLSearchParams(location.search || '');
  const company = String(params.get('company') || '')
    .trim()
    .toLowerCase();
  const routeName = company === 'tms' ? 'order-entry-tms' : 'order-entry';

  return (
    <ProtectedRoute routeName={routeName}>
      <OrderEntryPage />
    </ProtectedRoute>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route
        path="/hr-report"
        element={
          <ProtectedRoute routeName="hr-report">
            <HRReportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ecg-viewer"
        element={
          <ProtectedRoute routeName="ecg-viewer">
            <ECGViewer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute routeName="landing">
            <Landing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/commissions"
        element={
          <ProtectedRoute routeName="commissions">
            <Commissions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/commgross"
        element={
          <ProtectedRoute routeName="commissions">
            <CommGross />
          </ProtectedRoute>
        }
      />
      <Route
        path="/prod-mgrs"
        element={
          <ProtectedRoute routeName="prod-mgrs">
            <ProdMgrs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/daily-summary"
        element={
          <ProtectedRoute routeName="daily-summary">
            <DailySummaryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/all-star-rankings"
        element={
          <ProtectedRoute routeName="all-star">
            <AllStarRankings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/outstanding-orders"
        element={
          <ProtectedRoute routeName="outstanding-orders">
            <OutstandingOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/outstanding-orders-tms"
        element={
          <ProtectedRoute routeName="outstanding-orders-tms">
            <OutstandingOrdersTMS />
          </ProtectedRoute>
        }
      />
      <Route
        path="/performance"
        element={
          <ProtectedRoute routeName="performance">
            <TerrPerformance />
          </ProtectedRoute>
        }
      />
      {/* <Route path="/tzmms-orders" element={<TZMMSPOStatus />} /> */}
      <Route path="/order-entry" element={<ProtectedOrderEntryRoute />} />

      <Route
        path="/parse-invoice"
        element={
          <ProtectedRoute routeName="parse-invoice">
            <ParseInvoicePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bank-posting"
        element={
          <ProtectedRoute routeName="bank-posting">
            <BankPostingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/order-requirements"
        element={
          <ProtectedRoute routeName="order-requirements">
            <OrderRequirementsRoute />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tzmms-inv"
        element={
          <ProtectedRoute routeName="tzmms-inv">
            <TZMMSInvPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tzmms-activity"
        element={
          <ProtectedRoute routeName="tzmms-activity">
            <TZMMSActivityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enrollments"
        element={
          <ProtectedRoute routeName="enrollments">
            <EnrollmentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inv-tracker"
        element={
          <ProtectedRoute routeName="inv-tracker">
            <InvTrackerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products-on-back-order"
        element={
          <ProtectedRoute routeName="products-on-back-order">
            <ProductsOnBackOrderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer-summary"
        element={
          <ProtectedRoute routeName="customer-summary">
            <CustomerSummary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trackinginfo"
        element={
          <ProtectedRoute routeName="trackinginfo">
            <TrackingInfoPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default React.memo(AppContent);
